import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Consignment, Section } from '@/data/mockData';

interface ConsignmentState {
  sections: Section[];
  selectedIds: string[];
  loading: boolean;
  error: string | null;
  searchQuery: string;
  filters: Record<string, string>;
}

const initialState: ConsignmentState = {
  sections: [],
  selectedIds: [],
  loading: false,
  error: null,
  searchQuery: '',
  filters: {}
};

const consignmentSlice = createSlice({
  name: 'consignment',
  initialState,
  reducers: {
    setSections: (state, action: PayloadAction<Section[]>) => {
      state.sections = action.payload;
    },
    toggleSelection: (state, action: PayloadAction<string>) => {
      const id = action.payload;
      const index = state.selectedIds.indexOf(id);
      if (index === -1) {
        state.selectedIds.push(id);
      } else {
        state.selectedIds.splice(index, 1);
      }
    },
    selectAll: (state, action: PayloadAction<string[]>) => {
      state.selectedIds = action.payload;
    },
    clearSelection: (state) => {
      state.selectedIds = [];
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload;
    },
    setFilter: (state, action: PayloadAction<{ key: string; value: string }>) => {
      state.filters[action.payload.key] = action.payload.value;
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    importConsignment: (state, action: PayloadAction<string>) => {
      console.log('Importing consignment:', action.payload);
    },
    exportConsignments: (state) => {
      console.log('Exporting consignments');
    }
  }
});

export const {
  setSections,
  toggleSelection,
  selectAll,
  clearSelection,
  setSearchQuery,
  setFilter,
  clearFilters,
  importConsignment,
  exportConsignments
} = consignmentSlice.actions;

/** TODO: move to entities later */
/** @deprecated */
export default consignmentSlice.reducer;
